/* Pestañas de la guía de tallas y minitarjeta de compra rápida dentro del popup. */
(function () {
  document.addEventListener('click', function (e) {
    var tabBtn = e.target.closest('[data-mt-size-tab]');
    if (!tabBtn) return;
    var wrapper = tabBtn.closest('.mt-size-tabs');
    if (!wrapper) return;
    var target = tabBtn.getAttribute('data-mt-size-tab');
    wrapper.querySelectorAll('[data-mt-size-tab]').forEach(function (b) {
      b.classList.toggle('active', b === tabBtn);
    });
    wrapper.querySelectorAll('[data-mt-size-panel]').forEach(function (p) {
      p.classList.toggle('active', p.getAttribute('data-mt-size-panel') === target);
    });
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mt-unit-toggle]');
    if (!toggle) return;
    var isIn = toggle.getAttribute('data-mt-unit') === 'in';
    var nextUnit = isIn ? 'cm' : 'in';
    toggle.setAttribute('data-mt-unit', nextUnit);
    var panel = toggle.closest('.mt-size-tabs__panel') || document;
    panel.querySelectorAll('.mt-size-measurements').forEach(function (table) {
      table.setAttribute('data-mt-size-unit', nextUnit);
    });
  });

  /* Minitarjeta de compra rápida: combina el color y la talla marcados para
     encontrar la variante real (clave "Color__Talla"), actualiza el id oculto
     del formulario y, si cambió el color, también la foto de la tarjeta. */
  document.addEventListener('change', function (e) {
    var radio = e.target;
    var wrapper = radio.closest('.mt-size-guide-buy__options');
    if (!wrapper) return;

    var variantMap;
    try {
      variantMap = JSON.parse(wrapper.getAttribute('data-variant-map') || '{}');
    } catch (err) {
      variantMap = {};
    }

    var colorInput = wrapper.querySelector('.mt-size-guide-buy__colors input[type="radio"]:checked');
    var sizeInput = wrapper.querySelector('.mt-size-guide-buy__sizes input[type="radio"]:checked');
    var colorValue = colorInput ? colorInput.value : '';
    var sizeValue = sizeInput ? sizeInput.value : '';
    var key = colorValue + '__' + sizeValue;
    var variantId = variantMap[key];

    if (variantId) {
      var formId = wrapper.getAttribute('data-form-id');
      var form = document.getElementById(formId);
      var hiddenInput = form && form.querySelector('input[name="id"]');
      if (hiddenInput) hiddenInput.value = variantId;
    }

    if (radio.matches('.mt-size-guide-buy__colors input[type="radio"]')) {
      var imagesMap;
      try {
        imagesMap = JSON.parse(wrapper.getAttribute('data-color-images') || '{}');
      } catch (err2) {
        imagesMap = {};
      }
      var imgUrl = imagesMap[colorValue];
      var buyCard = wrapper.closest('.mt-size-guide-buy');
      var img = buyCard && buyCard.querySelector('.mt-size-guide-buy__image');
      if (imgUrl && img) img.src = imgUrl;
      var groupValue = wrapper.querySelector('.mt-size-guide-buy__group-value');
      if (groupValue) groupValue.textContent = colorValue;
    }
  });
})();
